import { IntroScreenUIConfig } from "../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../components/ui/scenario-info-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import GameManager from "../cvp-webgames-core/GameManager";
import Tools from "../cvp-webgames-core/Misc/Tools";
import BaseScenarioPart from "../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../cvp-webgames-core/pre-caching/pre-cache-item";
import { constants } from "../misc/constants";
import { CustomGameDataManager, PageType, updateMentorVideo } from "../misc/tools";
import { GameBaseScenario } from "./GameBaseScenario";

class Scenario5VideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'P.T.S.D. R.R.T.P. Poor Boundaries';
    }

	public videoKey = 'Video';
	public get mentorVidUrl(): string {
		return this.getItems()[1].src;
	}

	public cinematicKeys = {
		chapter0Resume: 'chapter0-resume',
		chapter1: 'chapter1', //played on step 2
		chapter1Part2: 'chapter1Part2', //played on step2c
		chapter1Resume: 'chapter1-resume',

		chapter2: 'chapter2', //played on step 5
		chapter2Part2: 'chapter2Part2', //played on step5c
		chapter2Resume: 'chapter2-resume',

		chapter3: 'chapter3', //played on step 7
		chapter3Part2: 'chapter3Part2', //played on step 7c
		chapter3Part3: 'chapter3Part3', //played on step 7e
		chapter3Resume: 'chapter3-resume',

		chapter4: 'chapter4', //played on step 9
		chapter4Part2: 'chapter4Part2', //played on step9c
		chapter4Resume: 'chapter4-resume',

		chapter5: 'chapter5', //played on step 11
		chapter5Resume: 'chapter5-resume',
    };

	public mentorKeys = {
		situation: 'mentor-2', //played on situation screen
		mentor1Correct: 'mentor-1', //played on ____ correct
		mentor1Incorrect: 'mentor-1', //played on ____ incorrect
		review: 'mentor-3', //played on review screen
		BnScn05All001: 'Bn-Scn-05-All-001',
		BnScn05All005: 'Bn-Scn-05-All-005',
		BnScn05All007: 'Bn-Scn-05-All-007',
		BnScn05All013: 'Bn-Scn-05-All-013',
		BnScn05All015: 'Bn-Scn-05-All-015',
		BnScn05All017: 'Bn-Scn-05-All-017',
		BnScn05All019: 'Bn-Scn-05-All-019',
		BnScn05All020: 'Bn-Scn-05-All-020',
		BnScn05All022: 'Bn-Scn-05-All-022',
		BnScn05All029: 'Bn-Scn-05-All-029',
		BnScn05All031: 'Bn-Scn-05-All-031',
		BnScn05All033: 'Bn-Scn-05-All-033',
		BnScn05All034: 'Bn-Scn-05-All-034',
		BnScn05All036: 'Bn-Scn-05-All-036',
		BnScn05All038: 'Bn-Scn-05-All-038',
		BnScn05All049: 'Bn-Scn-05-All-049',
		BnScn05All051: 'Bn-Scn-05-All-051',
		BnScn05All052: 'Bn-Scn-05-All-052',
		BnScn05All054: 'Bn-Scn-05-All-054',
		BnScn05All056: 'Bn-Scn-05-All-056',
		BnScn05All057: 'Bn-Scn-05-All-057',
		BnScn05All059: 'Bn-Scn-05-All-059',
		BnScn05All061: 'Bn-Scn-05-All-061',
		BnScn05All062: 'Bn-Scn-05-All-062',
		BnScn05All064: 'Bn-Scn-05-All-064',
		BnScn05All066: 'Bn-Scn-05-All-066',
		BnScn05All067: 'Bn-Scn-05-All-067',
		BnScn05All069: 'Bn-Scn-05-All-069',
		BnScn05All072: 'Bn-Scn-05-All-072',
		BnScn05All074: 'Bn-Scn-05-All-074',
		BnScn05All082: 'Bn-Scn-05-All-082',
		BnScn05All083: 'Bn-Scn-05-All-083',
		BnScn05All085: 'Bn-Scn-05-All-085',
		BnScn05All087: 'Bn-Scn-05-All-087',
		BnScn05All088: 'Bn-Scn-05-All-088',
		BnScn05All090: 'Bn-Scn-05-All-090',
		BnScn05All093: 'Bn-Scn-05-All-093',
		BnScn05All094: 'Bn-Scn-05-All-094',
		BnScn05All096: 'Bn-Scn-05-All-096',
		BnScn05All098: 'Bn-Scn-05-All-098',
		BnScn05All099: 'Bn-Scn-05-All-099',
		BnScn05All100: 'Bn-Scn-05-All-100',
		BnScn05All102: 'Bn-Scn-05-All-102',
		BnScn05All112: 'Bn-Scn-05-All-112',
		BnScn05All119: 'Bn-Scn-05-All-119',
		BnScn05All120: 'Bn-Scn-05-All-120',
		BnScn05All122: 'Bn-Scn-05-All-122',
		BnScn05All129: 'Bn-Scn-05-All-129',
		BnScn05All130: 'Bn-Scn-05-All-130',
		BnScn05All132: 'Bn-Scn-05-All-132',
		BnScn05All134: 'Bn-Scn-05-All-134',
		BnScn05All135: 'Bn-Scn-05-All-135',
		BnScn05All137: 'Bn-Scn-05-All-137',
		BnScn05All139: 'Bn-Scn-05-All-139',
		BnScn05All141: 'Bn-Scn-05-All-141',
		BnScn05All146: 'Bn-Scn-05-All-146',
		BnScn05All147: 'Bn-Scn-05-All-147',
		BnScn05All148: 'Bn-Scn-05-All-148',
		BnScn05All149: 'Bn-Scn-05-All-149',
    };
	
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: this.videoKey,
				src: process.env.PUBLIC_URL + '/assets/videos/scenario-05/video.mp4',
				type: PrecacheItemType.Video
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/mentor-vids/scn-05/Mentor-Bs-Scn-05-Full.mp4',
				type: PrecacheItemType.Video
			}
		];
	}
}

export const scenario5VideoSegments = new Scenario5VideoSegments();


export default class Scenario5 extends GameBaseScenario {
	public partId = 'scenario';

	public get MentorTalkingVideo(): string {
		return scenario5VideoSegments.mentorVidUrl;
    }
	
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return null;
    }

	public resumeScenarioFromArea(areaIndx: number): void {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			this.hudId = this.uiWrapper.displayHUD({
			});
			//resume on or after the first question
			let onDone: () => void = null;
			let chapterId: string = null;
			switch(areaIndx) {
				case 0:
					chapterId = scenario5VideoSegments.cinematicKeys.chapter1Resume;
					onDone = () => this.step4();
					break;
				case 1:
					chapterId = scenario5VideoSegments.cinematicKeys.chapter2Resume;
					onDone = () => this.step6();
					break;
				case 2:
					chapterId = scenario5VideoSegments.cinematicKeys.chapter3Resume;
					onDone = () => this.step8();
					break;
				case 3:
					chapterId = scenario5VideoSegments.cinematicKeys.chapter4Resume;
					onDone = () => this.step10();
					break;
				case 4:
					chapterId = scenario5VideoSegments.cinematicKeys.chapter5Resume;
					onDone = () => this.step12();
					break;
			}
	
			setTimeout(() => {
				this.playVideoChapter(this.partId, chapterId, () => {
					onDone();
				}, false)
			}, 250);
		});
	}

	public scenarioIndex(): number {
		return 4;
    } 

	public scenarioId(): PageType {
		return PageType.Scenario5;
    }
	private video: SingleVideoSegmentItem = scenario5VideoSegments.getItemByKey(scenario5VideoSegments.videoKey);

	public getScenarioVideoURL(): string {
		return this.video.src;
	}


	public introScreenInfo(): IntroScreenUIConfig {
		return null
	}

	private parts: BaseScenarioPart<GameBaseScenario>[] = [{
		partId: this.partId,
		scenario: this,
		videoUrl: [scenario5VideoSegments.getItemByKey(scenario5VideoSegments.videoKey).src],
		start: () => {
		},
		playVideoChapter: (chapterId: string, onDone: () => void) => {
			(this.playVideoChapter(this.partId, chapterId, onDone, false))
		}
	}]

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	start() {
		this.step0();
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	//load video
	step0() {
		// this.loadPart(this.partId, () => {
			this.step1();
		// });
	}

	//1.	Scenario Intro
	step1() {
		updateMentorVideo(true, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All001);

		this.hudId = this.uiWrapper.displayHUD({
		});
		this.uiWrapper.displayIntroScreenUI({
			title: 'Situation',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You are a clinician on an RRTP unit for Veterans who have experienced PTSD. You have been 
					working with this program for about three months and while you have been working with the VA 
					for a few years, you are still learning all the rules and procedures for this particular residential program.
				</p>
				<br />
				<p class="black-text">
					While you interact with all the Veterans in the milieu, you have been assigned the most recent admission, 
					Veteran Long, a woman who has been having difficulty understanding healthy boundaries with other patients 
					and staff. Other treatment team members have noticed that while she appears to mean well and have positive 
					intent, they are a bit uncomfortable by how close she stands to them when talking or her tendencies to touch people.
				</p>
				<br />
				<p class="black-text">
					The goal will be to identify the ERASE model, bystander intervention techniques, requirements outlined in VHA 
					Directive 5019.02, and VA Handbook 5979 throughout the scenario.
				</p>
			</div>
			`,
			spaceForMentor: true,
			audioUrls: null,
			onStartScenarioClicked: () => {
				this.step1b();
			}
		})
	}

	//1-b.	Time passes
	step1b() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter0Resume, () => {

			//UNCOMMENT FOR MENTOR
			updateMentorVideo(true, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All005);

			this.uiWrapper.displayIntroScreenUI({
				title: 'Information',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<p class="black-text">
						You are sitting at the front desk on the RRTP unit completing a progress note at the computer. Other staff are 
						also sitting at nearby tables. A Veteran is looking at a bulletin board directly across from the staff desk. 
						Veteran Long walks down the hallway and stops to also look at the bulletin board. You notice Veteran Long is 
						standing very close to the other Veteran.
					</p>
				</div>
				`,
				audioUrls: null,
				spaceForMentor: true,
				onStartScenarioClicked: () => {
					this.step2();
				}
			})
		});
	}

	//2.	Cinematic 1 (Video)
	step2() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter1, () => {
			this.step2b();
		}, false)
	}

	//2-b.	Time passes
	step2b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All007);

		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					The other Veteran takes one step away from Veteran Long and shakes their head. 
					Veteran Long continues to look at the bulletin board and says:
				</p>
			</div>
			`,
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step2c();
			},
			onReplayContentClicked: () => {
				this.step2();
			}
		})
	}

	//2-c.	Cinematic 1 Part 2 (Video)
	step2c() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter1Part2, () => {
			this.step3();
			this.step4();
		}, false)
	}

	//3.	Display UI
	step3() {
		
	}

	//4.	Question 1
	step4(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All013);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All015],
			isCorrect: false,
			description: 'You decide to do nothing. Sometimes ignoring a situation will make it go away.',
			feedbackHtml: 'Not the best answer! You observed the other Veteran looking uncomfortable by the closeness of Veteran Long. By not addressing the touching behavior it does not set clear expectations for appropriate interactions between patients on the unit. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All017]
		}, {
			title: 'Option 2',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All019, scenario5VideoSegments.mentorKeys.BnScn05All020],
			isCorrect: true,
			description: 'In an attempt to distract Veteran Long, you go up to the Veterans at the bulletin board and say: “Veteran Long, I heard you talking about the Take a Vet Fishing program. Are there any questions I can answer for you about it?”',
			feedbackHtml: 'Correct! This is an example of a distraction technique that can be useful to break up the interaction and provide more feedback if needed. Be aware of this behavior and if it is a pattern of behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All022]
		}, {
			title: 'Option 3',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All029],
			isCorrect: true,
			description: 'You decide to wait until the other Veteran walks away to then approach Veteran Long to provide feedback.',
			feedbackHtml: 'Correct! This is an example of delaying a response until a more appropriate moment. Addressing this response individually may result in a deeper conversation with the Veteran than if done out in the open. Be aware of this behavior and if it is a pattern of behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All031]
		}, {
			title: 'Option 4',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All149],
			isCorrect: false,
			description: 'You decide to stay at the nursing station but yell across the desk so the Veteran can hear you: “Veteran Long - no touching!”',
			feedbackHtml: 'Not the best answer! While this is a way to provide direct feedback, yelling is not clinically professional and may escalate the situation and draw other Veterans\' attention unnecessarily. If you have safety concerns for yourself or others, a stern voice may be appropriate but, in this instance, it may be useful to first give some feedback so that the Veteran understands the expectations. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All036]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario5,
			subtitle: ('Question 1'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario5VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step4b();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step4(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 0, 1, () => this.step2())
	}

	//4-b.	Time passes
	step4b() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter1Resume, () => {
			//UNCOMMENT FOR MENTOR
			updateMentorVideo(true, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All038);
			this.uiWrapper.displayIntroScreenUI({
				title: 'Information',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<p class="black-text">
						The other Veteran walks away from the bulletin board and you take the opportunity to discuss the situation further with Veteran Long.
					</p>
				</div>
				`,
				audioUrls: null,
				spaceForMentor: true,
				onStartScenarioClicked: () => {
					this.step5();
				}
			})
		});
	}

	//5.	Cinematic 2 (Video)
	step5() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter2, () => {
			this.step5b();
		}, false)
	}

	//5-b.	Time passes
	step5b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All147);
		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					Later that day at 2:00PM, you are sitting in the treatment team room discussing the cases with 4 other teammates.
					The team continues conversating as time passes.
				</p>
			</div>
			`,
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step5c();
			},
			onReplayContentClicked: () => {
				this.step5();
			}
		})
	}

	//5-c.	Cinematic 2 Part 2 (Video)
	step5c() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter2Part2, () => {
			this.step6();
		}, false)
	}

	//6.	Question 2
	step6(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All049);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All051, scenario5VideoSegments.mentorKeys.BnScn05All052],
			isCorrect: false,
			description: 'You say: “Wow, it sounds like you are pretty frustrated. Why don\'t we move on to someone else\'s case for now to give you some time to process.”',
			feedbackHtml: 'Not the best answer! While this response acknowledges that Judy is upset, it does not provide much support for the difficult situation and could benefit from allowing more space to support the staff and establish a positive culture. Try a different option that is consistent with ERASE principles of: (E)xpect mistreatment will occur. (R)ecognize episodes of mistreatment. (A)ddress mistreatment in real time. (S)upport the staff after the event. (E)stablish a positive culture. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All054]
		}, {
			title: 'Option 2',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All056, scenario5VideoSegments.mentorKeys.BnScn05All057],
			isCorrect: true,//testing pushing to the repo
			description: 'You say: “Wow, it sounds like you are pretty frustrated. If you are feeling this way, other staff may also feel frustration. Let\'s speak with the RRTP Director Dr. Dom to see if he can schedule sessions on how to have difficult conversations with Veteran patients.”',
			feedbackHtml: 'Correct! This response reminds Judy that addressing the situation in real time is an important consideration and one of the components of the ERASE model. Providing education and resources to stay contribute toward stablishing a positive culture for staff and patients. ERASE principles of: (E)xpect mistreatment will occur. (R)ecognize episodes of mistreatment. (A)ddress mistreatment in real time. (S)upport the staff after the event. (E)stablish a positive culture. Be aware of this behavior and if it is a pattern of behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All059]
		}, {
			title: 'Option 3',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All061, scenario5VideoSegments.mentorKeys.BnScn05All062],
			isCorrect: true,
			description: 'You say: “Wow, it sounds like you are pretty frustrated. You mentioned you were not sure what to do. Would you like to spend some time talking about potential options if something like that happens again?”',
			feedbackHtml: 'Correct! This response to the staff incorporates several of the ERASE components. (E)xpect that the behaviors may occur again, (R)ecognize and acknowledge that the behaviors were problematic, (A)ddress mistreatment in real time, (S)upport the staff member by stating it was frustrating, and (E)stablish a positive culture by allowing space to discuss. Be aware of this behavior and if it is a pattern of behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All064]
		}, {
			title: 'Option 4',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All066, scenario5VideoSegments.mentorKeys.BnScn05All067],
			isCorrect: true,
			description: 'You say: “Wow, it sounds like you are pretty frustrated. It also sounds like you handled it the best you could.”',
			feedbackHtml: 'Not the best answer! While this response provides support to Judy after the event, one of the components of the ERASE model, Judy mentioned that they were unsure how to respond and more could be done to anticipate how Judy might handle future events. Try a different option that is consistent with ERASE principles of: (E)xpect mistreatment will occur. (R)ecognize episodes of mistreatment. (A)ddress mistreatment in real time. (S)upport the staff after the event. (E)stablish a positive culture. This is not a clinical response to the behavior',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All069]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario5,
			subtitle: ('Question 2'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario5VideoSegments.getItemByKey('Feedback');

				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step7();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step6(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 1, 2, () => this.step5())
	}

	//7.	Cinematic 3 (Video)
	step7() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter3, () => {
			this.step7b();
		}, false)
	}

	//7-b.	Time passes
	step7b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All072);
		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You continue with the group and other group members appear to be interacting with each other appropriately. 
					The team continues conversating as time passes.
				</p>
			</div>
			`,
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step7c();
			},
			onReplayContentClicked: () => {
				this.step7();
			}
		})
	}

	//7-c.	Cinematic 3 Part 2 (Video)
	step7c() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter3Part2, () => {
			this.step7d();
		}, false)
	}

	//7-d.	Time passes
	step7d() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All074);
		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					The next day you are standing near the triage desk when Veteran Long comes up to you and talks to you. 
					There are no other individuals in the hallway currently.				
				</p>
			</div>
			`,
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step7e();
			},
			onReplayContentClicked: () => {
				this.step7c();
			}
		})
	}

	//7-e.	Cinematic 3 Part 3 (Video)
	step7e() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter3Part3, () => {
			this.step8();
		}, false)
	}

	//8.	Question 3
	step8(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All049);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All082, scenario5VideoSegments.mentorKeys.BnScn05All083],
			isCorrect: true,
			description: 'You provide a direct response and say: “It\'s against unit policy to accept gifts from patients and unfortunately I cannot accept the t-shirt.”',
			feedbackHtml: 'Correct! A clear and direct statement about unit policies and gifts provides direct feedback in the moment and clearly communicates a boundary.',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All085]
		}, {
			title: 'Option 2',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All087, scenario5VideoSegments.mentorKeys.BnScn05All088],
			isCorrect: false,
			description: 'You say: “Let\'s talk about this when we have our individual session next week.”',
			feedbackHtml: 'Not the best answer! While delaying the conversation for a more private setting may be useful, there is currently no one else around and it is not consistent with the ERASE concept of (A) addressing inappropriate comments in real time. Waiting more than a day or two to follow-up is probably too long to wait to provide feedback. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All090]
		}, {
			title: 'Option 3',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All093, scenario5VideoSegments.mentorKeys.BnScn05All094],
			isCorrect: true,
			description: 'You say: “I appreciate that you find value in working together. I will continue to support you while in this program however, our work together will need to come to an end once you are discharged.”',
			feedbackHtml: 'Correct! This response provides clear feedback.',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All096]
		}, {
			title: 'Option 4',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All098, scenario5VideoSegments.mentorKeys.BnScn05All099, scenario5VideoSegments.mentorKeys.BnScn05All100],
			isCorrect: false,
			description: 'You take the t-shirt and say: “Thank you, I enjoy working with you as well.” Then donate the t-shirt to the unit clothing shelves for Veterans on the unit who may be in need of clothing since it is against unit policy for staff to receive gifts from patients.',
			feedbackHtml: 'Not the best answer! This is a non-confrontational response that does not directly address the inappropriate gift or statement about prolonging a relationship after discharge. It is important to provide feedback to Veteran Long to set a boundary and help her develop better interpersonal skills, which she has identified as one of the goals of her program. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All148]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario5,
			subtitle: ('Question 3'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario5VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step9();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step8(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 2, 3, () => this.step7())
	}

	//9.	Cinematic 4 (Video)
	step9() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter4, () => {
			this.step9b();
		}, false)
	}

	//9-b.	Time passes
	step9b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All112);
		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					The next day you see Judy leaning against a counter at the staff desk and you walk over to say hello.				
				</p>
			</div>
			`,
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step9c();
			},
			onReplayContentClicked: () => {
				this.step9();
			}
		})
	}

	//9-c.	Cinematic 4 Part 2 (Video)
	step9c() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter4Part2, () => {
			this.step10();
		}, false)
	}

	//10.	Question 4
	step10(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All049);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All119, scenario5VideoSegments.mentorKeys.BnScn05All120],
			isCorrect: true,
			description: 'You say: “When you touched my body, I felt uncomfortable. Please respect physical boundaries of others in your interactions.”',
			feedbackHtml: 'Correct! You could say something direct and make a request to stop, "When you touched my body, I felt uncomfortable. Please respect physical boundaries of others in your interactions." You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All122]
		}, {
			title: 'Option 2',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All129, scenario5VideoSegments.mentorKeys.BnScn05All130],
			isCorrect: true,
			description: 'You say: “My fashion sense may not be all that great! Thanks for the tip. Let\'s refrain from gifts and touching though.”',
			feedbackHtml: 'Correct! You could use humor and a light tone. "My fashion sense may not be all that great! Thanks for the tip. Let\'s refrain from gifts and touching though. Remember, you are working on your interpersonal skills." You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All132]
		}, {
			title: 'Option 3',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All134, scenario5VideoSegments.mentorKeys.BnScn05All135],
			isCorrect: true,
			description: 'You say: “Well, I appreciate your thinking of me, but our program has a rule that we don\'t do gifts here. It is all about fairness and making sure that no one feels like they are getting singled out or that others are getting special treatment.”',
			feedbackHtml: 'Correct! You could reflect on unit rules. "Well, I appreciate your thinking of me, but our program has a rule that we don\'t do gifts here. It is all about fairness and making sure that no one feels like they are getting singled out or that others are getting special treatment." You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All137]
		}, {
			title: 'Option 4',
			mentorVid: scenario5VideoSegments.mentorVidUrl,
			mentorOption: [scenario5VideoSegments.mentorKeys.BnScn05All134, scenario5VideoSegments.mentorKeys.BnScn05All139],
			isCorrect: true,
			description: 'You say: “I would guess that you are trying to be friendly, but when you touch other people or place your hands on their body, some people may take it differently. I feel a bit uncomfortable with being touched.”',
			feedbackHtml: 'Correct! You could comment on intent versus impact. "I would guess that you are trying to be friendly, but when you touch other people or place your hands on their body, some people may take it differently. I feel a bit uncomfortable with being touched." You also need to report this behavior in the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>',
			mentorFeedback: [scenario5VideoSegments.mentorKeys.BnScn05All141]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario5,
			subtitle: ('Question 4'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your actions. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario5VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step11();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step10(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 3, 4, () => this.step9())
	}

	//11.	Cinematic 5 (Video)
	step11() {
		this.playVideoChapter(this.partId, scenario5VideoSegments.cinematicKeys.chapter5, () => {
			this.step12();
		}, false)
	}

	//12.	Scenario Recap
	step12() {
		this.setAreaForCurrentScenario(4, 5).then(() => {
			updateMentorVideo(false, scenario5VideoSegments.mentorVidUrl, scenario5VideoSegments.mentorKeys.BnScn05All146);
			this.uiWrapper.displayIntroScreenUI({
				title: 'Scenario Completed',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<p class="black-text">
						Let's recap what we were able to review and identify from our interactions with Veteran Long. When 
						Veterans demonstrate disruptive behaviors, there are a few things that are important to remember.
					</p>
					<br />
					<p class="black-text">The ERASE model stands for:
						<ul class="bullet">
							<li class="black-text">(E)xpect mistreatment will occur</li>
							<li class="black-text">(R)ecognize episodes of mistreatment</li>
							<li class="black-text">(A)ddress mistreatment in real time</li>
							<li class="black-text">(S)upport the staff after the event</li>
							<li class="black-text">(E)stablish a positive culture</li>
						</ul>
					</p>
					<br />
					<p class="black-text">
						Bystander intervention techniques that applies here is Direct Feedback must be done timely, 
						meaning at the time the behavior is occurring. Staff will maintain respectful interactions with 
						Veterans while outlining clear expectations. All disruptive behavior needs to be reported in 
						disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a>
					</p>
				</div>
				`,
				audioUrls: null,
				onStartScenarioClicked: () => {
					this.step13();
				}
			})
		})
	}

	//13.	AAR
	step13() {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			savedData.data.scenarios[this.scenarioIndex()].isCompleted = true;
			Tools.saveGame(savedData).then(() => {
				this.uiWrapper.displayAAR(PageType.MainMenu);
			})
		})
	}
}